import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';

import TulumRealityShowStore from '../../../store/TulumRealityShowStore';
import AnchorLiveFeed from '../../../components/anchorComponents/AnchorLiveFeed/AnchorLiveFeed';
import bcgImage from '../../../assets/AnchorPage/estonia-bg.png';

import LiveStreams from './LiveStreams';

import '../../../css/LiveBannerAnchor.css';


const TulumRealityShow = ({
  anchor,
  user,
  guestUser,
  anchorId,
  openContextualOverlay,
  slug,
  history,
  isSpotlighing,
  spotlighedAnchorUsername,
  spotlighedAnchorNickname,
  isLivePage,
  fetchStreamDetails,
  onNetworkError,
  extractIdFromSlug,
  galleriesAndVideosCount,
}) => {
  const {
    selectedStream,
    streams,
    selectedStreamID,
    chatAccess,
    shouldExcludeFeatured,
    isFollowingFeaturedStream,
    isStreamUnavailable,
    eventParticipants,
    hasNoLiveStream,
    streamData,
  } = TulumRealityShowStore;
  const isWhitelisted = user?.features?.includes('ANCHOR_PORTAL');
  const isAnchor = user?.user?.account?.anchor;
  const anchorIsActive = anchor?.active;

  const { authenticated } = user;
  let existingSubscription;
  if (authenticated) {
    const account = user?.user?.account;
    const { anchorSubscriptions } = account || {};
    const checkId = extractIdFromSlug();
    existingSubscription = anchorSubscriptions?.find((sub) => sub.subCategory === checkId);
  }

  const isSubscribed = Boolean(existingSubscription);

  const canSubscribeToAnchor = !isAnchor &&
    !isSubscribed &&
    isWhitelisted &&
    anchorIsActive &&
    galleriesAndVideosCount > 0;

  const onCameraSelect = useCallback((stream) => {
    TulumRealityShowStore.selectStream(stream);
  }, []);

  const handleStreamError = useCallback(() => {
    TulumRealityShowStore.toggleStreamError(true);
  }, []);

  const handleAllowStreamChangeOnError = useCallback(() => {
    TulumRealityShowStore.toggleAllowStreamChange(true);
  }, []);

  const formattedStreamObject = useMemo(() => ({
    id: streamData?.streamUri,
    url: streamData?.streamUri,
    provider: 'EXTERNAL',
  }), [streamData?.streamUri]);

  return (
    <div
      className="masthead live-anchor-banner-container"
      style={{
        background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${bcgImage}) center center / 250px`,
        paddingBottom: '5px',
        marginBottom: '20px',
      }}
    >
      <AnchorLiveFeed
        anchor={anchor}
        anchorId={anchorId}
        anchorVideoUrl={formattedStreamObject}
        background={anchor.promopic}
        canSubscribeToAnchor={canSubscribeToAnchor}
        chatService={chatAccess}
        chatServiceTempted={chatAccess}
        fetchStreamDetails={fetchStreamDetails}
        guestUser={guestUser}
        hasStreamError={hasNoLiveStream}
        history={history}
        isAlreadySubscribedToAnchor={isSubscribed}
        isAnchor={isAnchor}
        isEventActive={true}
        isLivePage={isLivePage}
        isSpotlighing={isSpotlighing}
        isTulumRealityShow={true}
        isWhitelisted={isWhitelisted}
        openContextualOverlay={openContextualOverlay}
        shouldDisplayPlayer={!hasNoLiveStream && !isStreamUnavailable && formattedStreamObject?.id}
        shouldHideVolumeRange={true}
        slug={slug}
        spotlighedAnchorNickname={spotlighedAnchorNickname}
        spotlighedAnchorUsername={spotlighedAnchorUsername}
        toggleStreamLoading={(isLoading) => TulumRealityShowStore.toggleStreamLoading(isLoading)}
        user={user}
        onAllowStreamChangeOnError={handleAllowStreamChangeOnError}
        onNetworkError={onNetworkError}
        onTulumStreamError={handleStreamError}
      />
      <LiveStreams
        eventParticipants={eventParticipants}
        isFollowingFeaturedStream={isFollowingFeaturedStream}
        selectedStreamID={selectedStreamID}
        shouldExcludeFeatured={shouldExcludeFeatured}
        user={user}
        streams={streams}
        onCameraSelect={onCameraSelect}
      />
    </div>
  )
}

export default observer(TulumRealityShow);
